import type { PropsWithChildren } from "react";

import { DialogProvider } from "@/shared/components/dialog";

import { PrivacySessionBoundary } from "./privacy-session-boundary";
import { QueryProvider } from "./query-provider";
import { ThemeProvider } from "./theme-provider";
import { ToastProvider } from "./toast-provider";

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <ThemeProvider>
      <QueryProvider>
        <PrivacySessionBoundary>{children}</PrivacySessionBoundary>
        <ToastProvider />
        <DialogProvider />
      </QueryProvider>
    </ThemeProvider>
  );
}
